import { SimpleChange } from '@angular/core';

export function hasChanges(change: SimpleChange): boolean {
  if (!change) return false;
  if (change === null || change === undefined) return false;

  return change.previousValue !== change.currentValue;
}
